var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNoData = function SvgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noData_svg__no_data_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".noData_svg__st1{opacity:.25;fill:#394954}")), /*#__PURE__*/React.createElement("g", {
    id: "noData_svg__no_data",
    transform: "translate(484 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7_4_",
    d: "M-359-104.7c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z",
    style: {
      fill: "#3cc",
      enableBackground: "new"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-3",
    className: "noData_svg__st1",
    d: "M-359 20.3c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy_6_",
    className: "noData_svg__st1",
    d: "M-234-104.7c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-4_1_",
    className: "noData_svg__st1",
    d: "M-234 20.3c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-2_9_",
    className: "noData_svg__st1",
    d: "M-109-104.7c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-5",
    className: "noData_svg__st1",
    d: "M-109 20.3c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-8_1_",
    className: "noData_svg__st1",
    d: "M-359 145.3c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-7_1_",
    className: "noData_svg__st1",
    d: "M-234 145.3c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "noData_svg__Rectangle-7-Copy-6_1_",
    className: "noData_svg__st1",
    d: "M-109 145.3c23 0 41.7 18.7 41.7 41.7 0 23-18.7 41.7-41.7 41.7-23 0-41.7-18.7-41.7-41.7 0-23 18.7-41.7 41.7-41.7z"
  }))));
};

export default SvgNoData;